import { render, staticRenderFns } from "./SideLink.vue?vue&type=template&id=95ab0462&"
import script from "./SideLink.vue?vue&type=script&lang=js&"
export * from "./SideLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports